module.exports = __webpack_public_path__ + "static/media/9D.62457f74.svg";